<!-- @format -->

<company-info-tag>
<!--
  <div
    style="
      position: fixed;
      right: 32px;
      bottom: 32px;
      opacity: 0.6;
      background: #000;
      color: #fff;
      font-size: 16px;
      padding: 1em;
    "
  >
    <dl>
      <dt>開発用</dt>
      <dd>
        <a onclick="{ devDel }">登録情報削除</a>
      </dd>
    </dl>
  </div>
-->
  <company-info-first
    if="{ state.phase === 'first' }"
    params="{ state.before }"
    prefs="{ state.prefs }"
    on-submit="{ (e) => update({ phase: 'form' }) }"
  ></company-info-first>

  <company-info-form
    if="{ state.phase=='form' }"
    params="{ state.before }"
    errors="{ state.errors }"
    prefs="{ state.prefs }"
    on-first="{ e => update({ phase: 'first' }) }"
    confirmation="{ onConfirm }"
  ></company-info-form>

  <company-info-confirm
    if="{ state.phase=='confirm' }"
    before="{ state.before }"
    params="{ state.params }"
    prefs="{ state.prefs }"
    on-first="{ e => update({ phase: 'first' }) }"
    on-form="{ e => update({ phase: 'form' }) }"
    on-submit="{ onSubmit }"
  ></company-info-confirm>

  <company-info-complete
    if="{ state.phase=='complete' }"
    on-first="{ e => update({ phase: 'first' }) }"
    on-form="{ e => update({ phase: 'form' }) }"
    errorMessage="{ state.errorMessage }"
  ></company-info-complete>

  <script>
    import di from "dependeny-injection";
    import first from "./company-info-first.riot";
    import form from "./company-info-form.riot";
    import confirm from "./company-info-confirm.riot";
    import complete from "./company-info-complete.riot";

    export default {
      components: {
        "company-info-first": first,
        "company-info-form": form,
        "company-info-confirm": confirm,
        "company-info-complete": complete,
      },
      state: {
        phase: "",
        before: {},
        prefs: [],
        params: {},
        errors: {},
      },
      async onMounted(props, state) {
        this.MenuApi = di.createApi();

        const res = await this.MenuApi.request("registeredCompany", "fetch");
        if (!res) {
          return
        }
        this.update({
          before: res ? res.data : "{}",
          prefs: res ? res.prefs : [],
          phase: res.applying ? "complete" : "first",
        });
      },
      async onConfirm(params) {
        try {
          const res = await this.MenuApi.request(
            "registeredCompany",
            "register",
            { phase: "confirm", ...params }
          );
          this.update({ phase: "confirm", params });
        } catch (e) {
          if (e.message == "invalid") {
            this.update({ errors: e.data });
            const container = window.document.querySelector(
              ".container_contents"
            );
            const top =
              this.$("p.error").previousElementSibling.getBoundingClientRect()
                .y + container.scrollTop;
            container.scrollTo({ top: top - 8, behavior: "smooth" });
            di.toast.push("入力に問題があります", "negative");
          } else {
            di.toast.push(e.message, "negative");
          }
        }
      },
      onSubmit() {
        this.MenuApi.request("registeredCompany", "register", {
          phase: "submit",
          ...this.state.params,
        })
          .then((data) => this.update({ phase: "complete" }))
          .catch((err) => di.toast.push(err.message, "negative"));
      },

      //devDel() {
      //  this.MenuApi.request("registeredCompany", "delete").then(async () => {
      //    const res = await this.MenuApi.request("registeredCompany", "fetch");
      //    this.update({ before: JSON.parse(res ? res.data : "{}") });
      //  });
      //},
    };
  </script>
</company-info-tag>
